<template>
  <v-container grid-list-lg ml-0 pl-0>
    <v-layout row wrap>
      <v-flex sm6>
        <h3 class="font-weight-bold">Trekking Agency Portal</h3>
      </v-flex>
      <v-flex lg12 v-if="trekking_agency.status===1">
        <div v-if="warnings">
          <v-alert
              :key="key"
              :value="true"
              color="error"
              icon="warning"
              outlined
              v-for="key in warnings.total_count">
            {{warnings[key-1].title}}
          </v-alert>
        </div>
      </v-flex>
      <v-flex lg12 v-else-if="trekking_agency.status && trekking_agency.status === 2">
        <div class="alert alert-warning">
          <v-alert
              class="mb-6"
              type="error">
            Sorry you can't make any requests until your account is verified by DOI
          </v-alert>
        </div>
      </v-flex>
      <v-flex lg12 v-else-if="trekking_agency.status && trekking_agency.status === 3">
        <div class="alert alert-warning">
          <v-alert
              class="mb-6"
              type="error">
            Sorry you can't make any requests, your account is rejected by DOI
            (Reason : {{trekking_agency.remarks}})
          </v-alert>
        </div>
      </v-flex>
      <v-flex lg12>
        <div class="alert alert-warning">
      <v-alert
          border="left"
          colored-border
          color="primary"
          elevation="2"
          class="mb-6 mt-4 portal-banner"
      >
        <div class="d-flex justify-space-between align-center flex-wrap">
          <div>
            <div class="text-h6 font-weight-bold">
              New Trekking Agency Portal Available
            </div>
            <div class="text-body-2 mt-1 grey--text text--darken-1">
              Experience a faster and more streamlined system for permit
              and agency-related services.
            </div>
          </div>

          <v-btn
              class="mt-3 mt-sm-0"
              color="primary"
              depressed
              rounded
              href="https://nepaliport-new.immigration.gov.np/trekking/login"
              target="_blank"
          >
            Visit New Portal
            <v-icon right>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </v-alert>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      trekking_agency:"AuthUser/trekking_agency",
      warnings:"AuthUser/warnings",
    }),
  },
  methods:{
  },
};
</script>


<style scoped>

</style>
